import { Keyword, keywordTreeTranslations } from '@livv/models';

/** Validate tree correspondence independently of summaries and the article's language. */
export const getKeywordTranslationError = (
    keyword: Keyword,
    keywordEn?: Keyword,
): string | undefined => {
    if (!keyword.treeId) return 'Sélectionnez d’abord un plan thématique FR.';
    if (!Object.prototype.hasOwnProperty.call(keywordTreeTranslations, keyword.treeId))
        return 'La correspondance FR/EN de cet ouvrage doit être configurée avant l’enregistrement.';
    const englishTreeId = keywordTreeTranslations[keyword.treeId];
    if (englishTreeId === null) {
        if (keywordEn?.treeId)
            return 'Cet ouvrage FR n’a pas de correspondant EN. Supprimez le plan thématique EN.';
    } else if (!keywordEn?.treeId) {
        return 'Sélectionnez le plan thématique EN correspondant à l’ouvrage FR.';
    } else if (keywordEn.treeId !== englishTreeId) {
        return 'Le plan thématique EN doit appartenir à l’ouvrage correspondant au plan FR.';
    }

    return undefined;
};
